import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recommendation-card',
  templateUrl: './recommendation-card.component.html',
  styleUrl: './recommendation-card.component.scss'
})
export class RecommendationCardComponent {
  @Input()
  recomm:any;

  @Input()
  showControls = true;

  @Output()
  public refresh = new EventEmitter()
  public imageUrl = environment.ImageUrl;

  constructor(private auth: AuthServiceService, private local: LocalServiceService, private toastr: ToastrService){}

  public async deleteRecomm(recomm) {
    const confirmation = await this.local.confirmYesNo({
      title: 'Delete recommendation',
      text: 'Are you sure you want to delete recommendation?',
      icon: 'warning'
    })
    if (confirmation.isConfirmed) {
      this.auth.deleteRecommendation(recomm.id).subscribe({
        next: () => {
          this.refresh.next(true)
          //this.fetchRecommdations();
        },
        error: err => {
          console.error(err);
          this.toastr.error("Error something went wrong when deleting recommendation")
        }
      })

    } else {
      this.toastr.info("Deleting recommendation cancelled")
    }


  }
  public like(recomm) {
    this.auth.toggleRecommendationReaction(recomm.id)
      .subscribe({
        next: (data) => {
          recomm.haveILiked = !recomm.haveILiked
          if (recomm.haveILiked) {
            recomm.likeCounts += 1
          } else {
            recomm.likeCounts -= 1
          }
        },
        error: (err) => {
          console.error(err);
          this.toastr.error("Unable to like please try again latter")
        }
      })
  }

}
